export default "__VITE_ASSET__D7L9oTCv__";